import { computed } from 'vue';
import { addSeconds } from "date-fns"

const LicensesUtils = (store = null) => {
    
    const allApplications = computed(() => {
        const tempA = store.state.licenses.licenses.map((license) => license.product.application)
        const tempB = tempA.filter((value, index, self) => {
            return self.findIndex(obj =>
                obj === value
            ) === index;
        });
        const res = tempB.sort((a,b) => {
            const nameA = a.toLowerCase()
            const nameB = b.toLowerCase()
            if (nameA < nameB) { return -1 }
            else if (nameA > nameB) { return 1 }
            else { return 0 }
        })
        return res
    })
    
    const allDevices = computed(() => { // all hardwares used on ANY of my license
        const tempA = store.state.licenses.licenses.filter((license) => license.current_status.activated && license.current_status.activeHardware && license.current_status.activeHardware.serial)
        const tempB = tempA.map((license) => license.current_status.activeHardware)
        const tempC = tempB.filter((hardware) => hardware.serial.length > 0)
        const tempD = tempC.filter((value, index, self) => {
            return self.findIndex(obj =>
                obj.label === value.label && obj.serial === value.serial
            ) === index;
        });
        const res = tempD.sort((a,b) => {
            const nameA = a.label.toLowerCase()
            const nameB = b.label.toLowerCase()
            if (nameA < nameB) { return -1 }
            else if (nameA > nameB) { return 1 }
            else { return 0 }
        })
        return res
    })

    const applicationsInfo = computed(() => {
        return allApplications.value.map((application) => {
            const latestVersion = store.state.licenses.licenses.filter((license) => license.product.application === application)[0].product.latestVersion
            const totalCounter = store.state.licenses.licenses.filter((license) => license.product.application === application).length
            const availableCounter = store.state.licenses.licenses.filter((license) => license.product.application === application && !license.current_status.activated).length
            return {
                "latest-version": `${latestVersion}`,
                "total": `${totalCounter}`,
                "available": `${availableCounter}`,
                "inuse": `${totalCounter-availableCounter}`
            }
        })
    })

    const getLicenseRemainingPendingTimeLabel = (pendingExpDate) => {
        const nowDate = new Date()
        const remainingSeconds = Math.floor((pendingExpDate-nowDate) / 1000)
        // Verify the pending is not finished
        if (remainingSeconds<=0) { return "-1" }
          // Calculate days, hours, minutes, and seconds
        const days = Math.floor(remainingSeconds / (24 * 60 * 60));
        const hours = Math.floor((remainingSeconds % (24 * 60 * 60)) / (60 * 60));
        const minutes = Math.floor((remainingSeconds % (60 * 60)) / 60);
        const seconds = remainingSeconds % 60;
        // Format the time difference
        let formattedDifference = '';
        if (days > 0) {
            formattedDifference += `${days}d `;
        }
        if (hours > 0 || days > 0) {
            formattedDifference += `${hours}h `;
        }
        if (minutes > 0 || hours > 0 || days > 0) {
            formattedDifference += `${minutes}m `;
        }
        formattedDifference += `${seconds}s`;
        return formattedDifference
    }

    const isOldActivation = (license) => {
        return license.current_status.activated && !license.current_status.activeUser && !license.current_status.activeHardware && !license.current_status.activationTimestamp
    }

    const isPendingNow = (license) => {
        return license.pending && ((license.pending.pending_release && license.pending.pending_release.remaining_time !== '-1') || (license.pending.pending_reactivate && license.pending.pending_reactivate.remaining_time !== '-1'))
    }

    const getTimeNowPlusSeconds = (numberOfSecondsFromNow) => {
        const now = new Date()
        const futureDateTime = addSeconds(now, numberOfSecondsFromNow)
        return futureDateTime
    }

    const licensesSortingFunction = (a, b) => {
        // Sort by application (alphabetical order...)
        if (a.product.application < b.product.application) return -1;
        if (a.product.application > b.product.application) return 1;
        // Sort by issue date (the most recent first)
        if (a.history.issue_date > b.history.issue_date) return -1;
        if (a.history.issue_date < b.history.issue_date) return 1;
        // Sort by version (the highest first)
        if (a.product.version > b.product.version) return -1;
        if (a.product.version < b.product.version) return 1;
        // Default if all the same: alphabetical order
        if (a.serial_number < b.serial_number) return -1;
        if (a.serial_number > b.serial_number) return 1;
        return 0;
    };

    return {
        allApplications,
        allDevices,
        applicationsInfo,
        getLicenseRemainingPendingTimeLabel,
        isOldActivation,
        isPendingNow,
        getTimeNowPlusSeconds,
        licensesSortingFunction
    };
}

export default LicensesUtils